
<div class="iq-mc-info-badge !rounded-[4px] bg-[#E9ECF1]">
    <ng-container *ngIf="settings() as settings">
        <div class="iq-mc-info-badge__body flex flex-row items-center text-xs  p-2">
            <mat-icon *ngIf="settings.showInfoIcon" class="iq-mc-info-badge__body--info-icon" svgIcon="app:error"></mat-icon>
            <span class="iq-mc-info-badge__body--message ml-2">{{settings?.message}}</span>
        </div>
    </ng-container>
</div>